import { constants } from '../config';

const initialState = {
  memory: null,
  currentBlockKey: null,
  status: 'idle', // idle | initializing | loading | saving | generating | polling | error
  error: null,
  initDone: false,
  loadDone: false,
  saveDone: false,
  loadedForLineId: null,
};

export default function biographicalEditorReducer(state = initialState, action) {
  switch (action.type) {
    case constants.INIT_MEMORY:
      return { ...state, status: 'initializing', error: null, initDone: false };
    case constants.INIT_MEMORY_SUCCESS:
      return {
        ...state,
        status: 'idle',
        initDone: true,
        memory: action.payload,
      };
    case constants.INIT_MEMORY_FAIL:
      return { ...state, status: 'error', error: action.error, initDone: false };

    case constants.GET_MEMORY:
      return { ...state, status: 'loading', error: null, loadDone: false };
    case constants.GET_MEMORY_SUCCESS:
      return {
        ...state,
        status: 'idle',
        loadDone: true,
        memory: action.payload,
        loadedForLineId: action.lineId,
      };
    case constants.GET_MEMORY_FAIL:
      return { ...state, status: 'error', error: action.error, loadDone: false };

    case constants.SAVE_BLOCK:
      return { ...state, status: 'saving', error: null, saveDone: false };
    case constants.SAVE_BLOCK_SUCCESS: {
      const updatedBlock = action.payload;
      const existingBlocks = state.memory?.blocks ?? [];
      const blockExists = existingBlocks.some((b) => b.block_key === updatedBlock.block_key);
      const updatedBlocks = blockExists
        ? existingBlocks.map((b) => (b.block_key === updatedBlock.block_key ? updatedBlock : b))
        : [...existingBlocks, updatedBlock];
      return {
        ...state,
        status: 'idle',
        saveDone: true,
        memory: { ...state.memory, blocks: updatedBlocks },
      };
    }
    case constants.SAVE_BLOCK_FAIL:
      return { ...state, status: 'error', error: action.error, saveDone: false };

    case constants.GENERATE_MEMORY:
      return { ...state, status: 'generating', error: null };
    case constants.GENERATE_MEMORY_SUCCESS:
      return {
        ...state,
        status: 'polling',
        memory: { ...state.memory, status: 'generating' },
      };
    case constants.GENERATE_MEMORY_FAIL:
      return { ...state, status: 'error', error: action.error };

    case constants.POLL_STATUS_SUCCESS: {
      const { status: memStatus, word_count: wordCount, final_text: finalText } = action.payload;
      const donePolling = memStatus === 'completed' || memStatus === 'ready' || memStatus === 'draft';
      return {
        ...state,
        status: donePolling ? 'idle' : 'polling',
        memory: {
          ...state.memory,
          status: memStatus,
          word_count: wordCount ?? state.memory?.word_count,
          final_text: finalText ?? state.memory?.final_text,
        },
      };
    }
    case constants.POLL_STATUS_FAIL:
      return { ...state, status: 'error', error: action.error };

    case constants.SET_CURRENT_BLOCK:
      return { ...state, currentBlockKey: action.blockKey, saveDone: false };

    case constants.RESET:
      return { ...initialState };

    default:
      return state;
  }
}
